'use client';

import {createContext, PropsWithChildren, useContext, useMemo} from 'react';

type EnvContextType = {
  cookieDomain: string;
};

const fallbackCookieDomain =
  process.env.NODE_ENV === 'development' ? 'localhost' : '.rustore.ru';

const EnvContext = createContext<EnvContextType>({
  cookieDomain: fallbackCookieDomain,
});

export const EnvContextProvider = ({
  cookieDomain = fallbackCookieDomain,
  children,
}: PropsWithChildren<{cookieDomain: string | undefined}>) => {
  const contextValue = useMemo<EnvContextType>(
    () => ({
      cookieDomain,
    }),
    [cookieDomain],
  );

  return (
    <EnvContext.Provider value={contextValue}>{children}</EnvContext.Provider>
  );
};

export const useEnvContext = () => useContext(EnvContext);
